import { ErrorMessage, useField } from "formik";

import "./InputField.scss";

const CheckBoxField = ({ name, label, type, ...props }: any) => {
  const [field, meta] = useField(name);
  return (
    <div className="Input-Field">
      <div className="Check-Box-Field">
        <input
          type={type}
          className={`${
            meta.error && meta.touched
              ? "Check-Box-Field-Box Check-Box-Field-Box-Effect"
              : "Check-Box-Field-Box"
          }`}
          {...field}
          {...props}
        />
        <label className="Check-Box-Field-Label" htmlFor={field.name}>
          {label}
          {props.required === true ? (
            <label className="Input-Field-Label-Red">&nbsp;*</label>
          ) : (
            ""
          )}
        </label>
      </div>
      <ErrorMessage
        name={field.name}
        component="label"
        className="Field-Error"
      />
    </div>
  );
};
export default CheckBoxField;
